<script>
  import { onMount } from 'svelte';
  import StepFour from './components/StepFour/StepFour.svelte';
  import StepThree from './components/StepThree/StepThree.svelte';
  import StepOne from './components/StepOne/StepOne.svelte';
  import StepTwo from './components/StepTwo/StepTwo.svelte';
  import { config, initData, step } from '../../../store/common';
  import { Dialog } from '../../../elements';

  onMount(() => {
    initData($config.customerId);
  });
</script>

<Dialog>
  {#if $step === 1}
    <StepOne />
  {:else if $step === 2}
    <StepTwo />
  {:else if $step === 3}
    <StepThree />
  {:else if $step === 4}
    <StepFour />
  {/if}
</Dialog>
